<kendo-avatar *ngIf="avatarSrc" [shape]="'rounded'"  [imageSrc]="avatarSrc" [size]="size"></kendo-avatar>
<kendo-avatar *ngIf="!avatarSrc && !!initials" [shape]="'rounded'"  [initials]="initials" [size]="size"></kendo-avatar>

